<template>
    <div class="behavior-analysis">
        <div class="behavior-analysis-top">
            <div class="title">教师备授课教学行为分析</div>
            <!-- <div class="more" @click="goMore">更多 ></div> -->
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="behavior-analysis-content">
            <div style="width: 100%; height: 100%" id="data_pie"></div>
            <div class="chart-error" v-show="isShow">
                <div class="detail">
                    <span class="detail">暂无数据</span>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
<script>
import { getTeachingActivityAnalysisAPI } from "@/service/api"
export default {
    name: "tea-active-analyse",
    props: {
        name: String,
        screenHeight: Number,
        titleHeight: Number,
        areaParams: Object,
        regionId: String,
        isTowns: String
    },
    data() {
        return {
            screenWidth: 0, //屏幕宽度
            boxWrapStyleObj: {
                height: "",
            },
            contentStyleObj: {
                height: "",
                marginTop: "0px",
            },
            legendIndex: "课前",
            data: [],
            pieData: [],
            defaultPointList: [],
            // smallPieColorArr: ["#4180FF", "#018AE6", "#03C4B0"],
            smallPieColorArr: ["#0368E3", "#F36D81", "#7672ED"],
            bigPieColorArr: [
                "#0368E3",
                "#329ED6",
                "#26C0E2",
                "#A0E3BA",
                "#FFDD84",
                "#F39C83",
                "#F36D81",
                "#E581AD",
                "#E2BFE9",
                "#7672ED",
            ],
        };
    },
    watch: {
        screenHeight: "initBoxHeight",
        titleHeight: "initBoxHeight"
    },
    methods: {
        /**
        * @name 教学活动分析
        */
        async getTeachingActivityAnalysis() {
            let _this = this;
            let params = {
                province: 320000,
                city: 320100,
                districtId: '',
                regionId: 'da103541c2084644b4cabd2120e00b2c',
            }
            // let res = await getTeachingActivityAnalysisAPI(params);
            let res = [
        {
          pointList: [
            {
              displayName: "同步课件",
              count: "21526732",
            },
            {
              displayName: "网盘使用",
              count: "38667285",
            },
            {
              displayName: "资源中心",
              count: "71374956",
            },
            {
              displayName: "课堂活动",
              count: "45293402",
            },
          ],
          sceneType: 1,
          sceneName: "课前",
          count: 176862375,
        },
        {
          pointList: [
            {
              displayName: "板书",
              count: "96483795",
            },
            {
              displayName: "课本",
              count: "63827959",
            },
            {
              displayName: "课件",
              count: "12749746",
            },
            {
              displayName: "讲评",
              count: "17847532",
            },
            {
              displayName: "学科工具",
              count: "152563045",
            },
          ],
          sceneType: 2,
          sceneName: "课中",
          count: 343472077,
        },
        {
          pointList: [
            {
              displayName: "布置作业",
              count: "1118346",
            },
            {
              displayName: "检查作业",
              count: "35787072",
            },
            {
              displayName: "资源分享",
              count: "286498",
            },
            {
              displayName: "微课分享",
              count: "878362",
            },
          ],
          sceneType: 3,
          sceneName: "课后",
          count: 38070278,
        },
      ]

            this.pieData = this.copyParamData(res);
            this.initPie();
        },

        /**
         * 初始化box高度
         */
        initBoxHeight() {
            //     let winHeight = window.innerHeight;
            //     if (winHeight < 900) {
            //       winHeight = 938;
            //     }
            //     let boxWrapHeight = (winHeight - 128 - 10 - 30 - 20) / 3;
            //     let contentHeight =
            //       boxWrapHeight - this.$refs.statisTitle.offsetHeight - 10;
            //     this.boxWrapStyleObj.height = boxWrapHeight + "px";
            //     this.contentStyleObj.height = contentHeight + "px";
        },
        /**
         * 根据参数数组加载饼状图
         */
        copyParamData(list) {
            let _this = this;
            let _pieData = [];
            _this.defaultPointList = [];
            for (let i = 0; i < list.length; i++) {
                let pieItemObj = {};
                pieItemObj.name = list[i].sceneName;
                pieItemObj.value = list[i].count;
                pieItemObj.selected = false;
                pieItemObj.pointList = [];

                for (let j = 0; j < list[i].pointList.length; j++) {
                    let pointObj = {};
                    pointObj.name = list[i].pointList[j].displayName;
                    pointObj.value = list[i].pointList[j].count;
                    pointObj.proName = list[i].pointList[j].proName;
                    pieItemObj.pointList.push(pointObj);
                    _this.defaultPointList.push(pointObj);
                }
                _pieData.push(pieItemObj);
            }
            return _pieData;
        },
        /**
         * 加载饼状图
         */
        initPie() {
            let _this = this;
            let dataSourcePie = this.$echarts.init(
                document.getElementById("data_pie")
            );
            let bigPieColorList = [];
            let smallPieColorList = [];
            for (let i = 0; i < _this.pieData.length; i++) {
                smallPieColorList.push(_this.smallPieColorArr[i]);
            }
            for (let i = 0; i < _this.defaultPointList.length; i++) {
                bigPieColorList.push(_this.bigPieColorArr[i]);
            }

            let fontSize = 12;
            let smallPieRadius = "40%";
            let bigPieRadiusStart = "55%";
            let bigPieRadiusEnd = "70%";
            let smallMinAngle = 5;
            let bigMinAngle = 10;
            if (this.screenWidth <= 1680) {
                fontSize = 9;
                smallMinAngle = 10;
                bigMinAngle = 18;
            }
            if (this.screenWidth <= 1028) {
                fontSize = 8;
                smallMinAngle = 10;
                bigMinAngle = 18;
            }
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: function (params) {
                        if (params.data.proName) {
                            return params.name + ': ' + params.value + ' (' + params.percent + '%)--- ' + params.data.proName;
                        } else {
                            return params.name + ': ' + params.value + ' (' + params.percent + '%)'
                        }
                    }
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        minAngle: smallMinAngle, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                        avoidLabelOverlap: true, //是否启用防止标签重叠策略
                        selectedMode: "single",
                        radius: [0, smallPieRadius],
                        center: ["50%", "53%"], // 图的位置
                        label: {
                            normal: {
                                position: "inner",
                                fontSize: fontSize,
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        data: _this.pieData,
                        // color: ["#4180FF", "#018AE6", "#03C4B0"],
                        color: ["#0368E3", "#F36D81", "#7672ED"],
                    },
                    {
                        name: "",
                        type: "pie",
                        minAngle: bigMinAngle, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                        avoidLabelOverlap: true, //是否启用防止标签重叠策略
                        radius: [bigPieRadiusStart, bigPieRadiusEnd],
                        center: ["50%", "53%"], // 图的位置
                        label: {
                            normal: {
                                formatter: function (params) {
                                    if (params.data.proName) {
                                        return params.name + ' (' + params.data.proName + ') ';
                                    } else {
                                        return params.name
                                    }

                                },
                                fontSize: fontSize,
                            },
                        },
                        labelLine: {
                            normal: {
                                length: 12,
                                length2: 12,
                            },
                        },
                        data: _this.defaultPointList,
                        color: bigPieColorList,
                    },
                ],
            };
            dataSourcePie.clear();
            let isNotMerge = true;
            option.series[0].data[0].selected = true;
            this.legendIndex = option.series[0].data[0].name;
            option.series[1].data = option.series[0].data[0].pointList;
            dataSourcePie.setOption(option, true);
            // 处理点击事件
            dataSourcePie.on("click", function (params) {
                if (params.seriesIndex == 0) {
                    for (var i = 0; i < option.series[0].data.length; i++) {
                        option.series[0].data[i].selected = false;
                    }
                    option.series[0].data[params.dataIndex].selected = true;
                    _this.legendIndex = option.series[0].data[params.dataIndex].name;
                    option.series[1].data =
                        option.series[0].data[params.dataIndex].pointList;
                    dataSourcePie.clear();
                    dataSourcePie.setOption(option);
                }
            });
            window.addEventListener("resize", function () {
                dataSourcePie.resize();
            });
        },
    },
    mounted() {
        //获取屏幕宽度
        this.screenWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        this.initBoxHeight();
        this.$nextTick(() => {
            this.getTeachingActivityAnalysis();
            // this.initPie();
        });
    }
};
</script>
<style lang="scss" scoped>
.behavior-analysis {
    width: 100%;
    height: 250px;
    padding: 0 15px;
    border: 1px solid #053882;
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;

    .behavior-analysis-top {
        position: relative;
        text-align: center;

        // margin-bottom: 20px;
        .title {
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }

        .more {
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }

        .title-bg {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .behavior-analysis-content {
        width: 100%;
        height: 210px;
    }

    .top-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }

    .top-right {
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }

    .left-bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }

    .right-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}</style>
<style lang="scss"></style>